import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';
import clsx from 'clsx';
import i18n from 'i18next';

import { type TTranslateKey } from '@/types/i18n';

import { useStyles } from './ErrorText.styles';
import { type IErrorTextProps } from './types';

export const ErrorText = ({ error, placeholder, className, lines = 1 }: IErrorTextProps) => {
  const classes = useStyles({ lines, classes: { root: className } });
  const { t } = useTranslation();

  if (!error) {
    return (
      <Typography
        variant="caption"
        color="text.secondary"
        className={clsx({
          [classes.root]: true,
          [classes.hidden]: !placeholder,
        })}
      >
        {placeholder ? t(placeholder) : ''}
      </Typography>
    );
  }

  let text;

  if (typeof error === 'string') {
    text = i18n.exists(error) ? t(error as TTranslateKey) : error;
  } else {
    text = t(error.key, { ...error.vars });
  }

  return (
    <Typography className={classes.root} variant="caption" color="error">
      {text}
    </Typography>
  );
};
